import { buildReadModelsFromDescriptionPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateReadModelsFromDescription = async ({
  workflow,
  cardTypes,
  userDescription,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const { messages } = buildReadModelsFromDescriptionPrompt({
    workflow,
    cardTypes,
    userDescription,
    stream
  })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      useCase: 'read-models',
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'read-models',
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
